import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { FiThumbsUp } from "react-icons/fi";
import { workflowsService } from "services";
import { isAdmin, isSupervisor } from "utils/utils";
import { withTranslation } from "react-i18next";

class Dashboard_PendingRequests extends Component {
	constructor(props) {
		super(props);
		// console.log(props);

		this.state = {
			total: 0,
		};
	}

	componentDidMount() {
		this.getCounters();
	}

	async getCounters() {
		const counters = await workflowsService.getCounters();
		var total = 0;
		if (counters.ok) {
			if (isAdmin() || isSupervisor()) {
				total = counters.workflows_to_be_supervised_by_you;
			} else {
				total = counters.workflows_to_be_supervised_from_you;
			}

			this.setState({
				total,
			});
		}
	}

	render() {
		const { total } = this.state;
		const { t } = this.props;

		if (total > 0) {
			return (
				<div className="pending-requests-summary">
					<div className="counter">
						<span className="counter-item">{total}</span>
						<span className="text">{t("widgets.pendingRequests.notApproved")}</span>
					</div>

					<NavLink
						to="/pending-absences"
						className="btn btn-inline pending-requests-link"
					>
						{t("widgets.pendingRequests.viewPending")}
					</NavLink>
				</div>
			);
		} else {
			return (
				<div className="empty">
					<FiThumbsUp />
					<p>{t("widgets.pendingRequests.noPending")}</p>
				</div>
			);
		}
	}
}

export default withTranslation()(Dashboard_PendingRequests);
